import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer__container" }
const _hoisted_2 = { class: "footer__wrap" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "footer__info" }, "powered by Stranded Flight Solutions", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StyledFooter = _resolveComponent("StyledFooter")!

  return (_openBlock(), _createBlock(_component_StyledFooter, null, {
    default: _withCtx(() => [
      _createElementVNode("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.version), 1)
        ])
      ])
    ]),
    _: 1
  }))
}